import { NetworkPrinter, PrinterType, UsbDevice } from "../models/printer";

/**
 * Fake printers that are only injected into the available printer lists in dev
 * mode, so the printer settings page can be exercised without the printer agent
 * running. One USB and one network device per printer type.
 */
const FAKE_USB_PRINTERS: UsbDevice[] = [
  {
    id: { id_vendor: "0dev", id_product: "0001", serial: `FAKE-USB-${PrinterType.Ticket}` },
    product: "Fake Ticket Printer (USB)",
    manufacturer: "DevMock",
  },
  {
    id: { id_vendor: "0dev", id_product: "0002", serial: `FAKE-USB-${PrinterType.BrotherQL}` },
    product: "Fake BrotherQL Printer (USB)",
    manufacturer: "DevMock",
  },
];

const FAKE_NETWORK_PRINTERS: NetworkPrinter[] = [
  {
    ip: "192.0.2.11",
    port: 9100,
    mac: "de:ad:be:ef:00:01",
    vendor: "DevMock Fake Ticket Printer (Network)",
    update_time: new Date(0).toISOString(),
  },
  {
    ip: "192.0.2.12",
    port: 9100,
    mac: "de:ad:be:ef:00:02",
    vendor: "DevMock Fake BrotherQL Printer (Network)",
    update_time: new Date(0).toISOString(),
  },
];

export const devUsbPrinters = (): UsbDevice[] => (import.meta.env.DEV ? FAKE_USB_PRINTERS : []);

export const devNetworkPrinters = (): NetworkPrinter[] =>
  import.meta.env.DEV ? FAKE_NETWORK_PRINTERS : [];
